import React from 'react';
import {
  FaFolderOpen,
  FaUserAlt,
  FaCalendarAlt,
  FaPlus,
  FaTag,
} from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

const statusColors = {
  'Pending': 'bg-yellow-200 text-yellow-800',
  'In Progress': 'bg-blue-200 text-blue-800',
  'Complete': 'bg-green-200 text-green-800',
};

const ProjectList = ({ projects, onSelect, onAddProject }) => {
  const navigate = useNavigate();

  const normalizedProjects = Array.isArray(projects)
    ? projects
    : Array.isArray(projects?.results)
    ? projects.results
    : [];

  const sortedProjects = [...normalizedProjects].sort((a, b) =>
    new Date(b.created_at) - new Date(a.created_at)
  );

  return (
    <div className="bg-white p-6 rounded shadow mt-6 border border-yellow-300">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-xl font-bold text-black flex items-center gap-2">
          <FaFolderOpen className="text-orange-500" /> Your Projects
        </h3>
        <button
          onClick={onAddProject}
          className="flex items-center gap-2 bg-orange-500 hover:bg-orange-600 text-white text-sm px-4 py-2 rounded shadow transition"
        >
          <FaPlus /> New Project
        </button>
      </div>

      {sortedProjects.length === 0 ? (
        <p className="text-gray-500 italic">No projects found. Start by creating one!</p>
      ) : (
        <ul className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
          {sortedProjects.map((project) => {
            const status = project.status || 'Pending';
            const statusClass = statusColors[status] || 'bg-gray-200 text-gray-700';

            return (
              <li
                key={project.id}
                onClick={() => navigate(`/dashboard/projects/${project.id}`)}
                className="cursor-pointer bg-yellow-50 hover:bg-yellow-100 transition duration-200 p-4 rounded-lg border border-gray-200 shadow-sm hover:shadow-md"
              >
                <div className="flex items-center justify-between mb-1">
                  <div className="font-semibold text-lg text-black">
                    {project.title || project.name || 'Untitled Project'}
                  </div>
                  <span
                    className={`text-xs px-2 py-1 rounded-full font-medium flex items-center gap-1 ${statusClass}`}
                  >
                    <FaTag className="text-xs" />
                    {status}
                  </span>
                </div>

                <div className="text-sm text-gray-600 mb-1 flex items-center gap-2">
                  <FaUserAlt className="text-gray-400" /> Owner ID: {project.owner ?? 'N/A'}
                </div>

                <div className="text-sm text-gray-600 flex items-center gap-2">
                  <FaUserAlt className="text-gray-400" />
                  Clients:{' '}
                  {Array.isArray(project.client_names) && project.client_names.length > 0
                    ? project.client_names.join(', ')
                    : 'Unnamed Client'}
                </div>

                {project.created_at && (
                  <div className="text-xs text-gray-500 mt-2 flex items-center gap-1">
                    <FaCalendarAlt className="text-gray-400" />
                    Created: {new Date(project.created_at).toLocaleDateString()}
                  </div>
                )}
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
};

export default ProjectList;